import React from "react";
import type { ClassDetailResponse } from "../../../../../interfaces/classDetail";
import { useLocalization } from "../../../../../stores/localizationContext";
import "./SeatsSummary.scss";

interface SeatsSummaryProps {
  data: ClassDetailResponse;
}

const SeatsSummary: React.FC<SeatsSummaryProps> = ({ data }) => {
  const { t } = useLocalization();

  const cards = [
    {
      key: "total",
      label: t("total_seats_label"),
      value: data.class_seats_limit,
      nagwa: data.standard_seats_limit,
      affiliate: data.affiliate_seats_limit,
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" className="seats-summary__icon">
          <path d="M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm-96 261.3C128 397.8 197.8 352 352 352s224 45.8 224 133.3c0 11.8-9.6 21.3-21.3 21.3H149.3c-11.8 0-21.3-9.6-21.3-21.3z"/>
        </svg>
      ),
    },
    {
      key: "reserved",
      label: t("reserved_seats_label"),
      value: data.class_seats_reserved,
      nagwa: data.standard_seats_reserved,
      affiliate: data.affiliate_seats_reserved,
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" className="seats-summary__icon">
          <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM472 200l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0z"/>
        </svg>
      ),
    },
    {
      key: "available",
      label: t("available_seats_label"),
      value: data.class_seats_available,
      nagwa: data.standard_seats_available,
      affiliate: data.affiliate_seats_available,
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" className="seats-summary__icon">
          <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM504 312l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"/>
        </svg>
      ),
    },
  ];

  return (
    <div className="seats-summary">
      {cards.map((card) => (
        <div key={card.key} className="seats-summary__card">
          <div className="seats-summary__top">
            <span className="seats-summary__number">{card.value}</span>
            {card.icon}
          </div>
          <p className="seats-summary__label">{card.label}</p>
          <p className="seats-summary__breakdown">
            {t("nagwa_students", "Nagwa Students")}: {card.nagwa}
            {" • "}
            {t("affiliate_students_label")}: {card.affiliate}
          </p>
        </div>
      ))}
    </div>
  );
};

export default SeatsSummary;
